import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import Loader from "@/components/loader/Loader.vue";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { alertError } from "@/util/dialog";
const POLL_INTERVAL_MS = 10000;
let GenerationInProgress = class GenerationInProgress extends Vue {
  constructor(...args) {
    super(...args);
    // Server data (HTML attributes arrive as strings)
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "speachId", void 0);
    _defineProperty(this, "initialStatus", void 0);
    _defineProperty(this, "elapsedSeconds", void 0);
    _defineProperty(this, "timeoutMinutes", void 0);
    _defineProperty(this, "status", 'PENDING');
    _defineProperty(this, "elapsed", 0);
    _defineProperty(this, "speachTotal", 0);
    _defineProperty(this, "speachDone", 0);
    _defineProperty(this, "speachFailed", 0);
    _defineProperty(this, "lastMessage", '');
    _defineProperty(this, "busy", false);
    _defineProperty(this, "pollTimer", null);
    _defineProperty(this, "tickTimer", null);
  }
  get isGenerating() {
    return this.status === 'PENDING';
  }
  get isError() {
    return this.status === 'ERROR' || this.status === 'TIMEOUT';
  }
  get isTimeout() {
    return this.status === 'TIMEOUT';
  }
  get timeoutMinutesNb() {
    return parseInt(this.timeoutMinutes, 10) || 30;
  }
  get elapsedLabel() {
    const total = Math.max(0, Math.floor(this.elapsed));
    const m = Math.floor(total / 60);
    const s = total % 60;
    return m > 0 ? `${m} min ${s}s` : `${s}s`;
  }
  mounted() {
    this.status = this.initialStatus || 'PENDING';
    this.elapsed = parseInt(this.elapsedSeconds, 10) || 0;
    if (this.isGenerating) {
      this.startPolling();
    }
  }
  beforeDestroy() {
    this.stopPolling();
  }
  startPolling() {
    this.stopPolling();
    // Live elapsed ticker (1s), corrected by each poll.
    this.tickTimer = window.setInterval(() => {
      if (this.isGenerating) this.elapsed += 1;
    }, 1000);
    this.pollTimer = window.setInterval(() => this.fetchStatus(), POLL_INTERVAL_MS);
    // First fetch immediately to get the speach aggregate for the bar.
    this.fetchStatus();
  }
  stopPolling() {
    if (this.pollTimer !== null) {
      window.clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
    if (this.tickTimer !== null) {
      window.clearInterval(this.tickTimer);
      this.tickTimer = null;
    }
  }
  async fetchStatus() {
    try {
      const {
        data
      } = await axios.get('/recorder/aiSpeachGenerator/chapterGenerationStatus', {
        params: {
          chapterId: this.chapterId
        }
      });
      this.status = data.status || this.status;
      this.elapsed = data.elapsedSeconds ?? this.elapsed;
      this.speachTotal = data.speachTotal ?? 0;
      this.speachDone = data.speachDone ?? 0;
      this.speachFailed = data.speachFailed ?? 0;
      this.lastMessage = data.lastMessage ?? '';
      if (this.status === 'DONE') {
        // Chapter is ready → reload the recorder so the real editor shows.
        this.stopPolling();
        document.location.reload();
      } else if (!this.isGenerating) {
        // ERROR / TIMEOUT → stop polling, wait for user action.
        this.stopPolling();
      }
    } catch (e) {
      // transient error — keep polling
      console.warn('chapterGenerationStatus poll failed', e);
    }
  }
  async relaunch() {
    this.busy = true;
    try {
      const fd = new FormData();
      fd.append('chapterId', String(this.chapterId));
      await axios.post('/recorder/aiSpeachGenerator/relaunchChapter', fd);
      this.status = 'PENDING';
      this.elapsed = 0;
      this.startPolling();
    } catch (e) {
      alertError(this.$t('aiContent.error'));
    } finally {
      this.busy = false;
    }
  }
  async cancel() {
    this.busy = true;
    try {
      const fd = new FormData();
      fd.append('chapterId', String(this.chapterId));
      await axios.post('/recorder/aiSpeachGenerator/cancelChapterGeneration', fd);
      // Row deleted → chapter is now manual → reload into the normal editor.
      document.location.reload();
    } catch (e) {
      alertError(this.$t('aiContent.error'));
      this.busy = false;
    }
  }
};
__decorate([Prop({
  required: true
})], GenerationInProgress.prototype, "chapterId", void 0);
__decorate([Prop({
  default: ''
})], GenerationInProgress.prototype, "speachId", void 0);
__decorate([Prop({
  default: 'PENDING'
})], GenerationInProgress.prototype, "initialStatus", void 0);
__decorate([Prop({
  default: '0'
})], GenerationInProgress.prototype, "elapsedSeconds", void 0);
__decorate([Prop({
  default: '30'
})], GenerationInProgress.prototype, "timeoutMinutes", void 0);
GenerationInProgress = __decorate([Component({
  components: {
    Loader,
    Icon,
    StandardButton
  }
})], GenerationInProgress);
export default GenerationInProgress;